export const primary = '#6fbeeb'
export const secondary = '#1674A9'